import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TUserList, userListSliceType } from "./userList.type";
import { userList } from "./api";

const initialState: userListSliceType = {
  userList: [],
  userOptions: [],
  // driverList: [],
  // driverOptions: [],
  allUserOptions: [],
};

const userListSlice = createSlice({
  name: "userList",
  initialState,
  reducers: {
    setAllUsers: (
      state,
      action: PayloadAction<{ allUsers: userListSliceType["userList"], companyId: string }>
    ) => {
      const { allUsers, companyId } = action.payload;
      const userList: TUserList = [];
      allUsers.forEach((user) => {
        if (user.role !== "D" || (user.role === "D" && user.company === companyId)) {
          userList.push(user);
        }
      });
      state.userList = userList;
      console.log({ userList })
      state.userOptions = userList.map((item) => ({
        label: `${item?.name?.fName} ${item?.name?.lName}`,
        value: item?._id,
      }));
      state.allUserOptions = allUsers;
      // state.driverList = driverList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userList.fulfilled, (state, action) => {
      state.userList = action.payload;
    });
  },
});

export const { setAllUsers } = userListSlice.actions;

export default userListSlice.reducer;
